import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../common/navbar";
import Header from "../common/header";
// import Cookies from "js-cookie";
import { getBreadcrumps } from "../../helper/apicalls/course";
import GlobalLoader from "../common/GlobalLoader";

const DashboardLayout = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isShowSearch, setIsShowSearch] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [headerName, setHeaderName] = useState("");
  const [isShowHeader, setIsShowHeader] = useState(false);
  const [headerExtra, setHeaderExtra] = useState(null);
  // const role = Cookies.get("role");
  const location = useLocation();
  // const navigate = useNavigate();
  const currentPath = location.pathname;
  const paths = currentPath.split("/").filter(Boolean);
  const breadcrumbCacheRef = useRef({});
  const [breadcrumbData, setBreadcrumbData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reportBreadcrumbLinks, setReportBreadcrumbLinks] = useState(null);

  let courseKey = null;

  if (paths.length >= 3 && paths[1] === "course") {
    courseKey = paths[2];
  } else if (paths.length >= 3 && paths[1] === "eval") {
    courseKey = paths[2];
  } else if (
    paths.length >= 4 &&
    (paths[1] === "materials" || paths[1] === "question-bank") &&
    paths[2] === "course"
  ) {
    courseKey = paths[3];
  } else if (
    paths.length >= 2 &&
    paths[0] === "teacher" &&
    paths[1] === "homework"
  ) {
    const params = new URLSearchParams(location.search);
    courseKey =
      params.get("course") ||
      params.get("courseid") ||
      params.get("course_id") ||
      null;
    if (!courseKey && paths.length >= 4 && paths[2] === "course" && paths[3]) {
      courseKey = paths[3];
    }
  }

  useEffect(() => {
    if (!courseKey) {
      setBreadcrumbData(null);
      return;
    }

    if (breadcrumbCacheRef.current[courseKey]) {
      setBreadcrumbData(breadcrumbCacheRef.current[courseKey]);
      return;
    }

    const fetchBreadcrumbData = async () => {
      try {
        setLoading(true);
        const data = await getBreadcrumps(courseKey);
        if (data && data.length > 0) {
          breadcrumbCacheRef.current[courseKey] = data;
          setBreadcrumbData(data);
        }
      } catch (err) {
        console.error("Error fetching breadcrumb data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBreadcrumbData();
  }, [courseKey]);

  const isCompactHeaderRoute =
    currentPath.includes("/blog") ||
    currentPath.includes("/guides-materials") ||
    currentPath.includes("/overall") ||
    currentPath.includes("/teacher/dashboard");

  const page =
    currentPath.includes("/admin/institution") ||
    (currentPath.includes("/institution") &&
      currentPath !== "/institution/reports") ||
    currentPath === "/admin/preference" ||
    currentPath === "/admin/initial-test" ||
    currentPath === "/admin/courses" ||
    currentPath.includes("/admin/course") ||
    currentPath.includes("/admin/eval") ||
    currentPath.includes("/admin/question-bank") ||
    currentPath.includes("/admin/materials") ||
    currentPath.includes("/admin/overall") ||
    currentPath.includes("/admin/guides-materials") ||
    currentPath.includes("/admin/blog") ||
    currentPath.includes("/admin/videos") ||
    currentPath.includes("/admin/reports") ||
    currentPath.includes("/institution/overall") ||
    currentPath.includes("/institution/reports") ||
    currentPath.includes("/institution/guides-materials") ||
    currentPath.includes("/institution/blog") ||
    currentPath.includes("/institution/videos") ||
    currentPath === "/admin/iq_test" ||
    currentPath.startsWith("/teacher");

  return (
    <div className="d-flex w-100">
      <GlobalLoader visible={loading} text="Loading..." />
      <Navbar
        mobileMenuOpen={mobileNavOpen}
        onToggleMobileMenu={() => setMobileNavOpen((v) => !v)}
        setIsShowHeader={setIsShowHeader}
      />
      <div className="app-main-container">
        {page && !isShowHeader && (
          <Header
            headerName={headerName}
            onToggleMobileMenu={() => setMobileNavOpen((v) => !v)}
            mobileMenuOpen={mobileNavOpen}
            breadcrumbData={breadcrumbData}
            customBreadcrumbLinks={reportBreadcrumbLinks}
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
            isShowSearch={isShowSearch}
            setHeaderName={setHeaderName}
            setIsShowSearch={setIsShowSearch}
            headerExtra={headerExtra}
          />
        )}
        <main
          className={`app-main-content p-6  `}
          style={
            page && !isShowHeader && !currentPath.includes("profile")
              ? { marginTop: isCompactHeaderRoute ? "45px" : "73px" }
              : {}
          }
        >
          <Outlet
            context={{
              searchQuery,
              setHeaderName,
              setSearchQuery,
              setIsShowHeader,
              setIsShowSearch,
              setReportBreadcrumbLinks,
              setHeaderExtra,
            }}
          />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
